import { render, staticRenderFns } from "./news5.vue?vue&type=template&id=1f55113a&scoped=true&"
import script from "./news5.vue?vue&type=script&lang=js&"
export * from "./news5.vue?vue&type=script&lang=js&"
import style0 from "./news5.vue?vue&type=style&index=0&id=1f55113a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55113a",
  null
  
)

export default component.exports